export const saveToLocalStorage = (newResult) => {
    let items = localStorage.getItem('OpenAIresults')||0
    // console.log(items)
    if (!items) {
        localStorage.setItem('OpenAIresults',JSON.stringify([newResult]))
    }
    else {
        items = JSON.parse(items)
        localStorage.setItem('OpenAIresults', JSON.stringify([...items, newResult]))

    }
}

export const deleteLocalStoarge = () => {
    localStorage.setItem('OpenAIresults', [])
}